module.exports = __webpack_public_path__ + "static/media/kominfo-login.1be2a7ae.png";